export const isObject = (value) => value && typeof value === 'object';
export const isPrimitiveObject = (value) => isObject(value) && value.constructor === Object;
